<template>
    <div>
        <b-row> 
            <b-col sm="12" md="3">
                <b-form-group>
                    <label
                        class="required"
                    >Local de Faturamento</label>
                    <b-form-select
                        :options="locaisFaturamento"
                        v-model="localFaturamento"
                        text-field="nome"
                        value-field="codigo"
                    ></b-form-select>
                </b-form-group> 
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label
                        class="required"
                    >Condições de Pagamento</label>
                    <b-form-select
                        :options="condicoesPagamento"
                        v-model="condicaoPagamento"
                        text-field="nome"
                        value-field="codigo"
                    ></b-form-select>
                </b-form-group> 
            </b-col>
        </b-row>
        <b-row>
            <b-col sm='12' md='3'>
                <b-form-group>
                    <label>CPF/CNPJ do Fornecedor</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            id="cpfcnpj"
                            placeholder="Digite o CPF ou CNPJ do fornecedor"
                            v-model="fornecedor.cnpjcpf"
                            v-mask="[
                                '###.###.###-##',
                                '##.###.###/####-##'
                            ]"
                            :state="validaTamanhoCpfCnpj ? null : false "
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button
                                variant="primary"
                                @click="pesquisarFornecedor()"
                                title="Clique para pesquisar o fornecedor"
                            >
                                <i class="fa fa-search"></i>
                            </b-button>
                        </b-input-group-append>
                        <b-form-invalid-feedback
                            >O CPF ou CNPJ está incompleto
                        </b-form-invalid-feedback>    
                    </b-input-group>
                </b-form-group>
            </b-col>
             <b-col sm="12" md="5">
                <b-form-group>
                    <label for="razaoSocial">Razão social</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            id="razaoSocial"
                            v-model="fornecedor.nome"
                            :disabled="true"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import PreContratoServicos from '../../preContrato/PreContratoServicos'
import { required } from 'vuelidate/lib/validators'


export default {
    components: {
        ModelListSelect
    },

    props: {
        condicoesPagamento: {
            type: Array,
            default: () => {}
        },
        locaisFaturamento: {
            type: Array,
            default: () => {}
        },
        contrato: {
            type: Object,
            default: () => {}
        },
        item: {
            type: Object,
            default: () => {}
        },
        acao: {
            type: String,
            default: () => ""
        }
    },
    
    data() {
        return {
            condicaoPagamento: '',
            localFaturamento: '',
            fornecedor: {
                cnpjcpf: '',
                nome: '',
                codFornecedor: '',
            },
            // vigenciaInicio: '',
            // vigenciaFim: '',
            invalid: ''
        }
    },

    methods: {
        verificarAcao() {
            if (this.acao == 'Inserir'){
                this.preencherFormInserir()
            } else {
                this.preencherFormAtualizar()
            }
        },

        preencherFormInserir() {
            this.fornecedor.codFornecedor = this.contrato.fornecedor.codFornecedor
            this.fornecedor.nome = this.contrato.fornecedor.nome
        },

        preencherFormAtualizar() {
            this.condicaoPagamento = this.item.codCondicaoPagamento
            this.localFaturamento = this.item.codLoc
            this.fornecedor.codFornecedor = this.item.codFornecedor != null ? this.item.codFornecedor : this.contrato.fornecedor.codFornecedor
            this.fornecedor.nome = this.item.nomeFornecedor != null ? this.item.nomeFornecedor : this.contrato.fornecedor.nome 
            // this.vigenciaInicio = this.$moment(this.item.vigenciaInicio).format('DD/MM/YYYY')
            // this.vigenciaFim = this.$moment(this.item.vigenciaFim).format('DD/MM/YYYY')
        },

        pesquisarFornecedor() {
            if (
                this.fornecedor.cnpjcpf.length == 14 ||
                this.fornecedor.cnpjcpf.length == 18
            ) {
                let cpfcnpjSemCaracteresEspeciais =
                    this.fornecedor.cnpjcpf.replace(/\D+/g, '')
                this.$store.dispatch('addRequest')
                PreContratoServicos.obterFornecedor(
                    cpfcnpjSemCaracteresEspeciais
                ).then((response) => {
                    if (response) {
                        if (response.success && response.data != null) {
                            this.erros = []
                            this.fornecedor.nome = response.data.nome
                            this.fornecedor.codFornecedor = response.data.codFornecedor
                        } else {
                            this.erros.push('Fornecedor não encontrado')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

    },

    computed: {
        condicoesGerais() {
            return {
                condicaoPagamento: this.condicaoPagamento,
                localFaturamento: this.localFaturamento,
                fornecedor: {
                    cnpjcpf: this.fornecedor.cnpjcpf,
                    nome: this.fornecedor.nome,
                    codFornecedor: this.fornecedor.codFornecedor,
                },
                // vigenciaInicio: this.vigenciaInicio,
                // vigenciaFim: this.vigenciaFim,
                invalid: this.$v.$invalid
            }
        },
        validaTamanhoCpfCnpj() {
            return (
                (this.fornecedor.cnpjcpf.length == '14' || this.fornecedor.cnpjcpf.length == '18') || this.fornecedor.cnpjcpf.length == '0' 
            )
        }
    },

    created() {
        this.verificarAcao()
    },

    watch: {
        condicoesGerais() {
            this.$emit('atualizarCondicoesGerais', this.condicoesGerais)
        }
    },

    validations: {
        condicaoPagamento: {
            required
        },
        // vigenciaInicio: {
        //     required,
        //     dataValida() {
        //         return this.vigenciaInicio != "Invalid date"
        //     }
        // },
        localFaturamento: {
            required
        }
    }
}

</script>

<style>

</style>